/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for delegate permission by institute
 * @export
 * @interface DelegatePermissionResponse
 */
export interface DelegatePermissionResponse {
    /**
     * Unique identifier of the delegate permission
     * @type {string}
     * @memberof DelegatePermissionResponse
     */
    id?: string;
    /**
     * Unique identifier of the assistant
     * @type {string}
     * @memberof DelegatePermissionResponse
     */
    assistantId?: string;
    /**
     * Firstname and lastname of the assistant
     * @type {string}
     * @memberof DelegatePermissionResponse
     */
    name?: string;
    /**
     * True if the medical person is allowed to manage a patient
     * @type {boolean}
     * @memberof DelegatePermissionResponse
     */
    allowed?: boolean;
}

/**
 * Check if a given object implements the DelegatePermissionResponse interface.
 */
export function instanceOfDelegatePermissionResponse(value: object): value is DelegatePermissionResponse {
    return true;
}

export function DelegatePermissionResponseFromJSON(json: any): DelegatePermissionResponse {
    return DelegatePermissionResponseFromJSONTyped(json, false);
}

export function DelegatePermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegatePermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'assistantId': json['assistantId'] == null ? undefined : json['assistantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'allowed': json['allowed'] == null ? undefined : json['allowed'],
    };
}

export function DelegatePermissionResponseToJSON(json: any): DelegatePermissionResponse {
    return DelegatePermissionResponseToJSONTyped(json, false);
}

export function DelegatePermissionResponseToJSONTyped(value?: DelegatePermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assistantId': value['assistantId'],
        'name': value['name'],
        'allowed': value['allowed'],
    };
}

